import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01e4bc39"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/shop_img_back.png",
  alt: ""
}, null, -1))
const _hoisted_2 = ["src"]

import { onMounted, ref, watch, useAttrs } from 'vue'
import { useWaterMark } from '@/util/useMark'
import axios from 'axios'

export default /*#__PURE__*/_defineComponent({
  props: {
  src: { // url地址
    type: String,
    required: true
  },
  isElImage: { // 是el-image渲染否照片
    type: Boolean,
    default: false
  },
  waterMark: { // 是否开启水印
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const props = __props

const loading = ref(false)



// 照片DOM
const imgage = ref(null)
const imgUrl = ref(props.src || '')

// 其他参数
const attr = useAttrs()

onMounted(() => {
  loadIamge()
})

// 加载生成照片
const loadIamge = async () => {
  if (props.waterMark && props.src) {
    loading.value = true
    try {
      await axios.get(props.src)
      imgUrl.value = (await useWaterMark(props.src)).url
    } catch (error) {
      loading.value = false
    } finally {
      loading.value = false
    }
  } else {
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _directive_loading = _resolveDirective("loading")!

  return (__props.isElImage)
    ? _withDirectives((_openBlock(), _createBlock(_component_el_image, _mergeProps({ key: 0 }, _unref(attr), {
        referrerPolicy: "no-referrer",
        lazy: "",
        src: imgUrl.value
      }), {
        error: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 16, ["src"])), [
        [_directive_loading, loading.value]
      ])
    : _withDirectives((_openBlock(), _createElementBlock("img", {
        key: 1,
        loading: "lazy",
        referrerpolicy: "no-referrer",
        src: imgUrl.value,
        id: "imgage",
        ref: (_value, _refs) => {
          _refs['imgage'] = _value
          imgage.value = _value
        }
      }, null, 8, _hoisted_2)), [
        [_directive_loading, loading.value]
      ])
}
}

})